import React, { useState } from 'react';
import GridContainer from '@/components/Grid/GridContainer';
import GridItem from '@/components/Grid/GridItem';
import { TextField } from '@mui/material';
import { useStyles } from '@/styles/templateInputStyles';
import Button from '@/components/CustomButtons/Button';
import EconsentModal from '@/views/Clients/EconsentModal';
import { Switch } from '@mui/material';

export default function EconsentTemplateForm({
  formInputs,
  onInputChange,
  labelStyle,
  disabled = false,
  logoData,
}) {
  const classes = useStyles();
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const closePreview = () => {
    setIsPreviewOpen(false);
  };

  const onPreview = async (e) => {
    e.preventDefault();
    setIsPreviewOpen(true);
  };

  const onSwitchChange = async () => {
    onInputChange({ target: { name: 'enabled', value: !formInputs?.enabled } });
  };

  return (
    <form>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <Switch
          color='primary'
          checked={formInputs?.enabled ?? false}
          onChange={onSwitchChange}
          disabled={disabled}
        />
        <h4>Enable</h4>
      </div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              padding: '5px',
            }}>
            <label style={labelStyle}>Title</label>
            <TextField
              variant='outlined'
              className={classes.root}
              multiline
              inputProps={{
                style: {
                  fontSize: '14px',
                  lineHeight: '1.3',
                  width: '100%',
                },
              }}
              minRows={1}
              maxRows={2}
              name='subject'
              value={formInputs?.subject ?? ''}
              onChange={onInputChange}
              disabled={disabled}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              padding: '5px',
            }}>
            <label style={labelStyle}>Heading</label>
            <TextField
              variant='outlined'
              className={classes.root}
              multiline
              inputProps={{
                style: {
                  fontSize: '14px',
                  lineHeight: '1.3',
                  width: '100%',
                },
              }}
              minRows={1}
              maxRows={2}
              name='heading'
              value={formInputs?.heading ?? ''}
              onChange={onInputChange}
              disabled={disabled}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              padding: '5px',
            }}>
            <label style={labelStyle}>Terms and Conditions</label>
            <TextField
              variant='outlined'
              className={classes.root}
              multiline
              inputProps={{
                style: {
                  fontSize: '14px',
                  lineHeight: '1.3',
                  width: '100%',
                },
              }}
              minRows={9}
              maxRows={12}
              name='body'
              value={formInputs?.body ?? ''}
              onChange={onInputChange}
              disabled={disabled}
            />
          </div>
        </GridItem>
      </GridContainer>

      {!disabled && (
        <div style={{ marginTop: '20px' }}>
          <Button
            variant='contained'
            color='primary'
            onClick={onPreview}
            type='button'>
            Preview
          </Button>
        </div>
      )}

      <EconsentModal
        econsentAgreed={!isPreviewOpen}
        econsent={formInputs}
        logo={logoData?.logo}
        onClose={closePreview}
        agreeEconsent={closePreview}
      />
    </form>
  );
}
